import React, { useState } from 'react'

const UserInfo: React.FC = () => {

    const [storageData, setStorageData] = useState<any>(() => {
        const saved = localStorage.getItem('loginDetails');
        try {
            return saved ? JSON.parse(saved) : {};
        } catch (e) {
            console.error('Failed to parse loginDetails from localStorage:', e);
            return {};
        }
    });
    return (
        <div className="container">
            <div className="info-box  mt-4">
                <div className="info-grid">
                    {storageData.state_code !== 0 && (
                        <div>
                            <strong>State:</strong>
                            <span> {storageData.state_name_english}</span>
                        </div>
                    )}
                    {storageData.zpcode !== 0 && (
                        <div>
                            <strong>ZP:</strong>
                            <span> {storageData.zpname}</span>
                        </div>
                    )}
                    {storageData.bpcode !== 0 && (
                        <div>
                            <strong>BP:</strong>
                            <span> {storageData.bpname}</span>
                        </div>
                    )}
                    {storageData.gpcode !== 0 && (
                        <div>
                            <strong>GP:</strong>
                            <span> {storageData.gpname}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default UserInfo